module.exports = __webpack_public_path__ + "static/media/NHaasGroteskTXPro-55Rg.a6feea6a.woff";